import { render } from "./OtherAmountView.vue?vue&type=template&id=06bbb8d8&scoped=true&ts=true"
import script from "./OtherAmountView.vue?vue&type=script&lang=ts"
export * from "./OtherAmountView.vue?vue&type=script&lang=ts"

import "./OtherAmountView.vue?vue&type=style&index=0&id=06bbb8d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bbb8d8"]])

export default __exports__